import { render, staticRenderFns } from "./ExamRelated.vue?vue&type=template&id=c70e4a0a&"
import script from "./ExamRelated.vue?vue&type=script&lang=js&"
export * from "./ExamRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports